<template>
  <div class="marquee">
    <!-- The list is rendered twice so the animation can loop seamlessly; the
         copy is hidden from screen readers. -->
    <ul class="marquee_track" :style="{ animationDuration: `${duration}s` }">
      <li v-for="item in items" :key="item"><span>{{ item }}</span></li>
    </ul>
    <ul class="marquee_track" :style="{ animationDuration: `${duration}s` }" aria-hidden="true">
      <li v-for="item in items" :key="item"><span>{{ item }}</span></li>
    </ul>
  </div>
</template>

<script>
// A row of words scrolling sideways, forever (the theme used a Splide
// auto-scroll for this).

export default {
  name: 'SiteMarquee',

  props: {
    items: { type: Array, required: true },
    duration: { type: Number, default: 30 },
  },
}
</script>

<style scoped>
.marquee {
  display: flex;
  gap: var(--marquee-gap, 60px);
  overflow: hidden;
  user-select: none;
}

.marquee_track {
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--marquee-gap, 60px);
  min-width: 100%;
  animation: marquee_scroll linear infinite;
}

/* A dot between every pair of words, as on the live site. */
.marquee_track li {
  display: flex;
  align-items: center;
  gap: var(--marquee-gap, 60px);
}

.marquee_track li::after {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--accent);
}

@keyframes marquee_scroll {
  from { transform: translateX(0); }
  to { transform: translateX(calc(-100% - var(--marquee-gap, 60px))); }
}

@media (prefers-reduced-motion: reduce) {
  .marquee_track {
    animation: none;
  }
}
</style>
